import { render, staticRenderFns } from "./reporting.vue?vue&type=template&id=4e5a3d36&"
import script from "./reporting.vue?vue&type=script&lang=js&"
export * from "./reporting.vue?vue&type=script&lang=js&"
import style0 from "./reporting.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports